var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      { staticClass: "table table-striped table-bordered w-100 tabla-default" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.interacciones[0], function (interaccion) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(interaccion.created_at))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.emisor))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.asegurado))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.resultado))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.error))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.producto))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.avance))]),
              _vm._v(" "),
              interaccion.receptor === "WEBCHAT"
                ? _c("td", [_vm._v("ChatBot")])
                : _c("td", [_vm._v(" WhatsApp ")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.opciones_encontradas))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.rapidez_servicio))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.evaluacion_servicio))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(interaccion.comentarios_servicio))]),
            ])
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v("\n        Distribución de opciones seleccionadas\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Reembolsos ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[1][0].Reembolsos)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Seguro de viaje ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[1][0].Seguros)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Productos ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[1][0].Productos)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Operadora ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[3][0].Operadoras)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Total Servicios")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(
                    _vm._s(_vm.interacciones[4]) + "\n                    "
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("\n        Distribución de encuestas\n    ")]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Total Encuestas Iniciadas ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[2].cantidad_total)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Rapidez Servicio ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[2].opciones_encontradas)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Opciones Encontradas ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[2].rapidez_servicio)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Evaluación Servicio ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.interacciones[2].evaluacion_servicio)),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2 col-sm-12" }, [
        _c(
          "button",
          {
            staticClass: "btn p-0 btn-block",
            staticStyle: { opacity: "1 !important" },
            attrs: { type: "button", disabled: "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "widget gray-bg",
                staticStyle: { "background-color": "#b5b5b5" },
              },
              [
                _c("span", [_vm._v(" Total Encuestas Completas ")]),
                _vm._v(" "),
                _c("h2", { staticClass: "font-bold" }, [
                  _vm._v(
                    _vm._s(_vm.interacciones[2].cantidad_total_respondidas)
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha hora")]),
        _vm._v(" "),
        _c("th", [_vm._v("Número de teléfono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rut asegurado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Resultado de la gestión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Detalle de error")]),
        _vm._v(" "),
        _c("th", [_vm._v("Producto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Porcentaje de avance")]),
        _vm._v(" "),
        _c("th", [_vm._v("Canal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones Encontradas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rapidez Servicio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Evaluación del Servicio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comentarios")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }